module.exports = __webpack_public_path__ + "static/media/caveFloor.4b11529b.png";